module.exports = __webpack_public_path__ + "img/big.a78e73bc.jpg";